import { post,get } from "./api_helper"
import * as url from "./url_helper"


function generateConfig(){
    const customHeader ={
        Authorization: "",
    }
    const config={
        customHeader,
    };
    const multiPartConfig={
        customHeader:{
            "Content-Type":"multipart/form-data",
        }
    };

    return {config,multiPartConfig}
}
// login
export const login=data=>{
    const{multiPartConfig} = generateConfig();
    return post(url.LOGIN, data, multiPartConfig)
}